/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './index.css';
import history from '../../../utils/history';
import { redirectNotification } from '../../../utils/commonUtil';

export const notify = (message, type) => {
  toast(message, {
    position: 'top-center',
    autoClose: true,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: toast.TYPE[`${type}`],
  });
};

export const systemInformationNotify = (message, type) => {
  toast(message, {
    position: 'top-center',
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    type: toast.TYPE[`${type}`],
  });
};

export const notificationNotify = (message, type) => {
  toast(message?.body, {
    position: 'top-center',
    autoClose: true,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: toast.TYPE[`${type}`],
    onClick: () => {
      if (message?.admin === 'true') {
        if (message?.redirect !== null) {
          redirectNotification('admin', message?.redirect, message);
        } else {
          history.push('/admin/notifications');
        }
      } else {
        if (message?.redirect !== null) {
          redirectNotification('client', message?.redirect, message);
        } else {
          history.push('/client/dashboard');
        }
      }
    },
  });
};
